import React, { Component } from 'react';
import './main.css';
import Rating from 'react-star-rating-component';
import $ from 'jquery';
import config from '../../API/DomainName';
import { USERURL, BASEURL } from '../../constant';
import facebook from "./../../../public/assets//facebook.svg";
import instagram from "./../../../public/assets//instagram.svg";
import linkedin from "./../../../public/assets//linkedin.svg";
import twitter from "./../../../public/assets//twitter.svg";
class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email_id: '',
      subscribed:'',
      subscribederror:'',
      current_path: window.location.pathname
    }
    this.handleSubscribe = this.handleSubscribe.bind(this);
  }
  componentDidMount() {
    console.log('window.location.pathname', window.location.pathname);
  }
  handleSubscribe = () => {

    if (this.state.email_id != '') {
      let subscribe = JSON.stringify({
        email_id: this.state.email_id,
        type: 1
      });
      let result = fetch(config.register + 'user/auth/subscribe', {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json; charset=UTF-8'
        },
        body: subscribe,
      });
      //let toastr = '';
      //toastr = window.toastr.success;
      /*
      toastr('', 'Thank You for your subscription!..', {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center"
      });
      */
      this.setState({
        email_id: "", subscribederror:'', subscribedsuccess:'Thank You for your subscription!'
      });
    } else {
      //let toastr = '';
      //toastr = window.toastr.error;
      this.setState({subscribedsuccess:'', subscribederror:'Enter Email Id'});
      /*
      toastr('', 'Enter Email Id', {
        positionClass: "toast-bottom-center",
        containerId: "toast-bottom-center"
      });
      */
    }
  };

  handleQueryfeedback = (e) => {
    e.preventDefault();
    var emailtext = JSON.stringify({
        rating: this.state.rating,
        rating1: this.state.rating1,
        feature: this.state.feature,
        decision: this.state.decision,
        verticals: this.state.verticals,
        suggession: this.state.suggession,
        message: this.state.message
    });
    //console.log("email text",emailtext)
    let result = fetch(config.register + 'user/auth/sendfeedback', {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        body: emailtext,
    });
    //let toastr = '';
    //toastr = window.toastr.success;

    
    window.$('#feedBackModal').modal('hide');

    alert('Thanks for your Feedback!..');

    $('.modal-backdrop').removeClass("show");
    setTimeout(function () {
        window.location.reload();
    }, 1000);
}
  
handleChangefeedback = (e) => {
  this.setState({ [e.target.name]: e.target.value });
  //console.log(e.target.name,e.target.value)
};
onStarClickfeedback(nextValue, prevValue, name) {
  this.setState({ rating: nextValue });
}
onStarClick1feedback(nextValue, prevValue, name) {
  this.setState({ rating1: nextValue });
}

onStarClickfeedback1(nextValue, prevValue, name) {
  this.setState({ rating1: nextValue });
}

onStarClickfeedback2(nextValue, prevValue, name) {
  this.setState({ rating2: nextValue });
}


onStarClickfeedback3(nextValue, prevValue, name) {
  this.setState({ rating3: nextValue });
}


onStarClickfeedback4(nextValue, prevValue, name) {
  this.setState({ rating4: nextValue });
}



  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  render() {
    const { rating, rating1, rating2, rating3, rating4 } = this.state;
    return (
      <React.Fragment>
        <footer className=" footer-color pt-5" id='footera'>
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-sm-5 col-md-5">
                <h4 className="mb-4">Stay updated!</h4>
                <div class="successmessage">{this.state.subscribedsuccess}</div>
                <div class="errormessage">{this.state.subscribederror}</div>
                <div className="d-flex mb-4">
                  {/* <form method='post' onSubmit={this.handleSubscribe}> */}
                  <div className="form-group mr-3 foot-input">
                    <input
                      className="form-control"
                      placeholder="Enter email address"
                      type="email"
                      name="email_id"
                      value={this.state.email_id}
                      onChange={this.handleChange}
                      title="Subscribe"
                    />
                  </div>
                  <button style={{ fontSize: '12px' }} className="btn blue-btn" onClick={this.handleSubscribe}>
                    Subscribe
                  </button>
                  {/* </form> */}
                </div>

                <div className="flex-item mb-4">
                  <a href="https://www.facebook.com/profile.php?id=100069862643218" target='_blank'>
                    <img src={facebook} className="social-icons" />
                  </a>
                  <a href="https://www.linkedin.com/company/bewise-in" target='_blank'>
                    <img src={linkedin} className="social-icons" />
                  </a>

                  <a href="https://www.instagram.com/bewise_in/" target='_blank'>
                    <img src={instagram} className="social-icons" />
                  </a>
                  <a href="https://twitter.com/BewiseIn" target='_blank'>
                    <img src={twitter} className="social-icons" />
                  </a>
                </div>
                {/* <h4 className="mb-3">Download BeWise App</h4>
                                <div className="flex-item mb-4">
                                    <a href="#">
                                        <img src={playstore} className="app-icons " />
                                    </a>
                                    <a href="#">
                                        <img src={aicon} className="app-icons " />
                                    </a>
                                </div> */}
              </div>
              <div className="col-xs-12 col-sm-7 col-md-7">
                <div className="row">
                  <div className="col-md-12">
                    {/* <h4 className="mb-4">BeWise wants to keep you updated</h4> */}
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-6">
                    <div className="company-subhead">
                      <a href="/about">About BeWise </a>
                    </div>
                    <div className="company-subhead">
                      <a href={USERURL} target='_blank'>BeWise Parent Portal</a>
                    </div>

                    <div className="company-subhead">
                        <a href={BASEURL + 'bewisepartnerplans'} target='_blank'>Partner Program</a>
                    </div>
                    { /*                                  
                    {(window.location.pathname != '/individual') && (
                      <div className="company-subhead">
                        <a href={BASEURL + 'individual'} target='_blank'>Partner Program – Individual</a>
                      </div>
                    )}
                    {(window.location.pathname != '/institution') && (
                      <div className="company-subhead">
                        <a href={BASEURL + 'institution'} target='_blank'>Partner Program – Institution</a>
                      </div>
                    )} */}

                    <div className="company-subhead">
                      <a href="mailto:contact@bewise.in">Work for BeWise</a>
                    </div>
                    <div className="company-subhead">
                      <a href='https://collegecampus.bewise.in/' target='_blank'>College Connect</a>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-6">
                    <div className="company-subhead">
                      <a href='mailto:contact@bewise.in'>Contact Us</a>
                    </div>
                    <div className="company-subhead">
                      <a href="/faq">FAQs</a>
                    </div>
                    <div className="company-subhead" data-toggle="modal" data-target="#termsConditions">
                      <a>Terms & Conditions</a>
                      {/* <a href="javascript:window.open('/termsconditions', 'termsconditions', 'width=auto,height=auto')">Terms &amp; Conditions</a> */}
                    </div>
                    <div className="company-subhead" data-toggle="modal" data-target="#privacy_policy">
                      <a>Privacy Policy</a>
                      {/* <a href="javascript:window.open('/privacypolicy', 'privacypolicy', 'width=auto,height=auto')">Privacy Policy</a> */}
                    </div>
                    <div className="company-subhead" data-toggle="modal" data-target="#feedBackModal">
                      <a href='javascript:;'>Give us Feedback</a>
                    </div>
                    { /* div className="company-subhead">
                      <a href={USERURL + "funlearning"} target='_blank'>Fun and Learning</a>
                    </div> */ }
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
                    className='modal fade review-modal'
                    id='feedBackModal'
                >
                    <div className='modal-dialog model-box modal-md' >
                        <div className='modal-content'>
                            <div className='modal-header'>
                                <h3 className='modal-title r-text'>Feedback</h3>
                                <button
                                    type='button'
                                    className='close'
                                    data-dismiss='modal'
                                    aria-label='Close'
                                >
                                    <span aria-hidden='true'>&times;</span>
                                </button>
                            </div>
                            <form method='post'
                                autoComplete='off'
                                onSubmit={this.handleQueryfeedback}>
                                <div className='modal-body'>
                                    <div className='rating-box '>
                                        <div className="row">
                                             
                                            <div className='col-md-12'>
                                                <div className='col'>
                                                    <p className='rating r-text'>
                                                    How easy was it to onboard BeWise?
                                                    </p>
                                                </div>
                                                <div className='col'>
                                                    <Rating
                                                        name="rating1"
                                                        value={rating1}
                                                        onStarClick={this.onStarClickfeedback1.bind(this)}
                                                        starCount={5}
                                                    />
                                                </div>
                                            </div>

                                            <div className='col-md-12'>
                                                <div className='col'>
                                                    <p className='rating r-text'>
                                                    Incase you were working with BeWise team - were they helpful and supportive in your onboarding?
                                                    </p>
                                                </div>
                                                <div className='col'>
                                                    <Rating
                                                        name="rating2"
                                                        value={rating2}
                                                        onStarClick={this.onStarClickfeedback2.bind(this)}
                                                        starCount={5}
                                                    />
                                                </div>
                                            </div>

                                            <div className='col-md-12'>
                                                <div className='col'>
                                                    <p className='rating r-text'>
                                                    How easy was it to navigate our page ? Flow / Categories / Layout /
                                                    </p>
                                                </div>
                                                <div className='col'>
                                                    <Rating
                                                        name="rating3"
                                                        value={rating3}
                                                        onStarClick={this.onStarClickfeedback3.bind(this)}
                                                        starCount={5}
                                                    />
                                                </div>
                                            </div>
                                            

                                            <div className='col-md-12'>
                                                <div className='col'>
                                                    <p className='rating r-text'>
                                                    Was all content & titles very clear for you to understand?
                                                    </p>
                                                </div>
                                                <div className='col'>
                                                    <Rating
                                                        name="rating4"
                                                        value={rating4}
                                                        onStarClick={this.onStarClickfeedback4.bind(this)}
                                                        starCount={5}
                                                    />
                                                </div>
                                            </div>

                                                                                       

                                            <div className="col-md-12">
                                                <div className='form-group'>
                                                    <label className='login-label r-text'>
                                                      What other product features will support you even better?                     </label>
                                                    <input
                                                        required
                                                        onChange={(e) => this.handleChangefeedback(e)}
                                                        name="feature" className='form-control'
                                                        type='text' />
                                                </div>
                                            </div>
                                             
                                            <div className="col-md-12">
                                                <div className='form-group'>
                                                    <label className='login-label r-text'>
                                                      What more should we include to help your growth?                     </label>
                                                    <input
                                                        required
                                                        onChange={(e) => this.handleChangefeedback(e)}
                                                        name="feature" className='form-control'
                                                        type='text' />
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className='form-group'>
                                                    <label className='login-label r-text'>
                                                    What is the one suggestion you will give for founders of BeWise?                     </label>
                                                    <input
                                                        required
                                                        onChange={(e) => this.handleChangefeedback(e)}
                                                        name="feature" className='form-control'
                                                        type='text' />
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <div className='form-group'>
                                                    <label className='login-label r-text'>
                                                        What other verticals / Needs we should add ?               </label>
                                                    <input
                                                        required
                                                        name="verticals" onChange={(e) => this.handleChangefeedback(e)}
                                                        className='form-control' type='text' />
                                                </div>
                                            </div>

                                            
                                            <div className="col-md-12">
                                                <div className='form-group'>
                                                    <label className='r-text '>What other topics would you like us add in "reviews" of parents to help you even better?  </label>
                                                    <textarea
                                                        required
                                                        className='form-control'
                                                        id='message'
                                                        rows='4'
                                                        cols='50'
                                                        name="message"
                                                        onChange={(e) => this.handleChangefeedback(e)}

                                                    ></textarea>
                                                </div>
                                            </div>

                                        </div>


                                    </div>

                                </div>
                                <div className='modal-footer' style={{ border: 'none' }}>
                                    <button type='button' className='btn  btn-default' data-dismiss='modal' aria-label='Close'>
                                        Cancel </button>
                                    <input
                                        type='submit'
                                        name='submit'
                                        value='Submit'
                                        className='btn btn-primary'
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

          <div className="modal fade " id="termsConditions">
            <div className="modal-dialog model-box modal-lg">
              <div className="modal-content">
                <div className="modal-header heading_colour">
                  <h3 className="modal-title r-text">Terms & Conditions</h3>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body termscond_body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="privacy-page">
                        <h5> General</h5>
                        <p className="termscond_para"><a href="https://www.bewise.in">www.BeWise.in</a> is an online platform and BEWISE App (“App”) is the mobile application, owned
                          by Wisdom Tech Solutions Private Limited, a private limited company incorporated under the
                          Companies Act, 2013, having its registered office at Karnataka (“Company”), represented by its
                          members, where such expression shall, unless repugnant to the context thereof, be deemed to
                          include its respective legal heirs, representatives, administrators, permitted successors and
                          assigns.</p>
                        <p className="termscond_para">
                          This website/App is an online platform/mobile application that is engaged in the business of
                          providing and facilitating parents make choice around their child’s “education and development”
                          by discovering preschool/daycare/ after school/events/ activity class for their child in and around
                          them. We ensure we provide details of relevant partners and constantly provide you
                          updates on them. On the other side, if you are an institution or an individual supporting this
                          “holistic education”, we also understand the pressures of growth and ability to effectively reach
                          target audience, benchmarking, and continuous improvement with feedback which are critical for
                          a sustainable future in a fast-paced digital economy. Hence, we provide them this platform to
                          overcome their problem of right audience through our website and App.</p>
                        <p className="termscond_para">
                          For the purpose of these Terms and Conditions, wherever the context so requires, the term "you"
                          or "user" shall mean any natural or legal person or entity including accessing or using the services
                          provided on this website/App. The terms “we”, “us” and “our” shall mean BeWise and the terms
                          ‘site’ or ‘website’ refers to <a href="https://www.bewise.in">www.BeWise.in</a>.</p>
                        <p className="termscond_para">
                          The headings of each section in this Agreement (as defined below) are only for the purpose of
                          organizing the various provisions under this Agreement in an orderly manner. These headings
                          shall not be used by either party to interpret the provisions contained with them in any manner.
                          Further, the headings have no legal or contractual value.</p>
                        <h5> Acceptance of our Terms</h5>
                        <p className="termscond_para">
                          By visiting this website/App, viewing, accessing or otherwise using any of the services or
                          information created, collected, compiled or submitted to BeWise, you agree to be bound by the
                          Terms and Conditions (<b>‘Terms’</b>) mentioned hereunder.</p>
                        <p className="termscond_para">
                          If you do not want to be bound by our Terms your only option is not to visit, view or otherwise use
                          the services of BeWise. You understand, agree and acknowledge that these Terms and the Privacy
                          Policy (please refer to the <b>Privacy Policy</b> section of the website/App for more information) of
                          BeWise, collectively, constitute a legally binding agreement between you and BeWise and that
                          your use of BeWise shall indicate your conclusive acceptance of this agreement (‘<b>Agreement</b>’).
                          You are advised to read the Terms and the Privacy Policy carefully before you use the services of
                          this site/App.</p>
                        <h5>
                          Eligibility</h5>
                        <p className="termscond_para">
                          Use of this site/App is available only to persons who can form legally binding contracts under
                          applicable law. Persons who are ‘incompetent to contract’ within the meaning of the laws
                          applicable to them in their respective jurisdiction are not eligible to use this site/App. You may
                          use this site/App only if your age is over 18 years and you are capable of forming binding contracts
                          under applicable law.</p>
                        <p className="termscond_para">
                          BeWise reserves the right to freeze your account and refuse to provide you with access to this
                          site/App if BeWise discovers that you are under the age of 18 years or otherwise not capable of
                          forming binding contracts. In case of a business entity, you represent that you have the necessary
                          authority to bind the entity to this Agreement.</p>
                        <p className="termscond_para">
                          Unless otherwise specified, the materials on this website/App are directed solely at those who
                          access this website/App from India. BeWise makes no representation that any content referred to
                          in the materials on this website/App are appropriate for use, or available outside India. Those
                          who choose to access this site/App from outside India are responsible for compliance with local
                          laws if and to the extent local laws are applicable.</p>
                        <h5>User’s Account</h5>
                        <p className="termscond_para">You are required to create an account on the website/App in order to use some of the features and
                          services offered by BeWise, including, without limitation to, booking for services, reviewing a
                          partner and availing offers and discounts. The use of any information you share with us
                          to create your account is governed by our Privacy Policy.</p>
                        <p className="termscond_para">
                          It is the user’s responsibility to keep the details of the account and password confidential and you
                          agree to accept responsibility for all activities that occur under your account or password. BeWise
                          shall not be liable to any person for any loss or damage which may arise as a result of any failure
                          by the user to protect the account details or the password. In case of any suspected breach, please

                          contact us immediately. If BeWise has reason to believe that there is likely to be a breach of
                          security or misuse of this site/App, we may require you to change your password or we may
                          permanently suspend your account without any liability to BeWise.</p>
                        <p className="termscond_para">You also agree to:</p>
                        <ul>
                          <li> provide true, accurate, current and complete information about yourself as prompted by
                            BeWise while signing up on this website/App.</li>
                          <li> maintain and promptly update the account related information to keep it true, accurate,
                            current and complete. If you provide any information that is untrue, inaccurate,
                            incomplete, or not current or if BeWise has reasonable grounds to suspect that such
                            information is untrue, inaccurate, not current or not in accordance with this Agreement,
                            or if in the opinion of BeWise, your use of this website/App breaches the terms of the
                            applicable law, or the rights of any person, or is detrimental in any way to BeWise, we will
                            have the right to indefinitely suspend or discontinue your account and refuse to provide
                            you with access to this site/App.</li>
                        </ul>
                        <p className="termscond_para">Further, you may be able to log into the website/App by linking a social media account such as
                          Facebook, Instagram, LinkedIn, twitter or Google accounts. You confirm that you are the owner
                          of any social media account you log in with and that you are entitled to disclose your social media
                          account information to us. Further, you give us permission to collect your authentication
                          information, and other information that may be available on or through your social media account
                          consistent with your applicable settings and instructions.</p>
                        <p className="termscond_para">
                          You are solely responsible for all activities that occur in your account. You agree to notify us
                          immediately of any unauthorized use of your account in order to enable us to take necessary
                          corrective action. You also agree that you will not allow any third party to use your account for the
                          purpose of transacting in your name on our website/App.</p>
                        <h5>User’s obligations</h5>
                        <p className="termscond_para">You are a restricted user of this website/App.</p>
                        <ul>
                          <li>You are bound not to cut, copy, distribute, modify, recreate, reverse engineer, distribute,
                            disseminate, post, publish or create derivative works from, transfer, or sell any information or
                            software obtained from the website/App. With our prior permission, limited use may be
                            allowed. For the removal of doubt, it is clarified that unlimited or wholesale reproduction,

                            copying of the content for commercial or non-commercial purposes and unwarranted
                            modification of data and information within the content of the website/App is not permitted.</li>
                          <li>You agree not to access (or attempt to access) the website/App and/or the materials or services
                            by any means other than through the interface that is provided by the website/App. The use of
                            deep-link, robot, spider or other automatic device, program, algorithm or methodology, or any
                            similar or equivalent manual process, to access, acquire, copy or monitor any portion of the
                            website/App or content, or in any way reproduce or circumvent the navigational structure or
                            presentation of the website/App, materials or any content, to obtain or attempt to obtain any
                            materials, documents or information through any means not specifically made available
                            through the website/App.</li>
                          <li>In places where this website/App allows you to post or upload data/information, you undertake
                            to ensure that such material is not offensive and in accordance with applicable laws.</li>
                          <li>You shall not impersonate any other party, create or use an account for anyone other than
                            yourself, provide an email address other than your own, create multiple accounts, except as
                            otherwise authorized by us, or provide or use false information of any kind.</li>
                        </ul>
                        <p className="termscond_para">We can (and you hereby expressly authorize us to) disclose any information about you to law
                          enforcement or other government officials, as we, in our sole discretion, believe necessary or
                          appropriate in connection with the investigation and/or resolution of possible crimes, especially
                          those that may involve personal injury.</p>
                        <p className="termscond_para">
                          You understand that we have the right at all times to disclose any information (including the
                          identity of the persons providing information or materials on the website/App) as necessary to
                          satisfy any law, regulation or valid governmental request. This may include, without limitation,
                          disclosure of the information in connection with investigation of alleged illegal activity or
                          solicitation of illegal activity or in response to a lawful court order.</p>
                        <p className="termscond_para">We have no obligation to monitor the materials posted on the website/App. We shall have the
                          right to remove or edit any content that, in our sole discretion, violates, or is alleged to violate,
                          any applicable law or either the spirit or letter of these Terms or for any other reason or no reason
                          if we consider it to be objectionable, in violation of the Terms or otherwise harmful to the
                          website/App or other users. Subject to the requirements of applicable law, we are not obligated to
                          return any of your content to you under any circumstances. Any review, which is derogatory,

                          defamatory or hateful and without any substantial evidence (e.g. photograph or video) may be
                          taken down at our sole discretion. Notwithstanding this right, YOU REMAIN SOLELY
                          RESPONSIBLE FOR THE CONTENT OF THE MATERIALS YOU POST ON THE WEBSITE/APP.
                          In no event shall we assume or have any responsibility or liability for any content posted or for
                          any claims, damages or losses resulting from use of content and/or appearance of content on the
                          website/App. You hereby represent and warrant that you have all necessary rights in and to all
                          content which you provide and all information it contains and that such content shall not infringe
                          any proprietary or other rights of third parties or contain any libelous, tortuous, or otherwise
                          unlawful information.</p>
                        <h5> Contents and submissions</h5>
                        <p className="termscond_para">We welcome your suggestions, comments and reviews regarding your experience using our
                          website/App. Any comments, ideas, suggestions, initiation, or any other content you contribute
                          to this site/App (including the name you submit with any content) will be deemed to include a
                          royalty-free, perpetual, irrevocable, nonexclusive right and license for BeWise to adopt, publish,
                          reproduce, disseminate, transmit, distribute, copy, use, create derivative works, display
                          worldwide, or act on such content, without additional approval or consideration, in any, media,
                          or technology now known or later developed for the full term of any rights that may exist in such
                          content, and you waive any claim to the contrary.</p>
                        <p className="termscond_para">The user acknowledges that all reviews and ratings that users submit to this website, for whatever
                          purpose, is public and not private/confidential information. BeWise specifically disclaims any
                          liability concerning such information and any actions resulting from the user’s participation in
                          such content, including any objectionable content.</p>
                        <p className="termscond_para">You represent and warrant that you own or otherwise control all of the rights to the content that
                          you contribute to this site/App and that use of your content by BeWise will not infringe upon or
                          violate the rights of any third party.</p>
                        <p className="termscond_para">You further represent that your content is truthful and accurate; and your content does not violate
                          these Terms or any applicable laws. If your content is a review, you represent and warrant that
                          you are the sole author of that review; the review reflects that you had no financial, competitive,
                          or other personal incentive to author or post a review that was not a fair expression of your honest
                          opinion.</p>
                        <p className="termscond_para">You assume all risks associated with your content, including anyone's reliance on its quality,
                          accuracy, or reliability, or any disclosure by you of information in your content that makes you

                          personally identifiable. While we reserve the right to remove content, we do not control actions
                          or content posted by our users and do not guarantee the accuracy, integrity or quality of any
                          content. You acknowledge and agree that content posted by users and any and all liability arising
                          from such content is the sole responsibility of the user who posted the content, and not us.</p>
                        <p className="termscond_para">
                          Any review posted by a user does not reflect our opinion in any way. Each and every review posted
                          on the website/App is the personal opinion of the user only. We are a neutral platform and solely
                          provide a means of communication between users. Any advertisements on the website/App are
                          published on an independent basis and there is no relation between the reviews of advertisers
                          those who have advertised on the website/App. If the business user believes that any particular
                          user’s review violates these Terms and our policies, the user can flag the review to our attention.
                          We may remove the review in our sole discretion.</p>
                        <h5> Services by Partners</h5>
                        <p className="termscond_para">
                          BeWise is not liable for the information provided by the individual and institutional partners (<b>‘Partners’</b>) listed on this website/App. The user understands that the
                          information provided by the Partners may or may not have been verified by BeWise,
                          therefore, the user shall exercise his/her own independent judgment while choosing from the
                          options of Partners listed on this website/App.</p>
                        <p className="termscond_para">
                          The information provided by the Partners is tentative and subject to change at any time
                          at their sole discretion and BeWise is not liable for any such change or modification in the
                          information provided by the Partners.</p>
                        <p className="termscond_para">
                          This website/App allows the user to access the information provided by the Partners and
                          contact them directly through call, text message or via e-mail. BeWise is not liable for
                          transmission of user’s phone number or such other information which may be shared by the user
                          with the Partners directly or indirectly through such means.</p>
                        <p className="termscond_para">
                          The user may avail services including the in-person services (such as availing services of nannies,
                          home tutors, etc.) for their ward from the Partners listed on this website/App at their
                          own risk. BeWise does not conduct any police verification or KYC of any of the Partners
                          listed on the website/App in any case, therefore, the user shall be solely responsible to conduct
                          independent verifications and choose from the listed options at its sole discretion. BeWise shall
                          not be liable upon occurrence of any undesirable event, whatsoever, arising out of non-verification
                          on part of the user or BeWise of such Partners.</p>
                        <h5> Communications</h5>
                        <p className="termscond_para">By using this website/App, it is deemed that you have consented to receiving calls, autodialed
                          and/or pre-recorded message calls, e-mails and SMSs from us at any time with the use of the
                          contact information that has been provided by you for the use of this website/App which is subject
                          to the Privacy Policy. This includes contacting you through information received through other
                          parties. This consent to be contacted is for purposes that include and are not limited to
                          clarification, marketing and promotional calls, e-mails and messages. In case you wish to stop
                          being contacted by us for the same, you may send us an e-mail to that effect at <a href="mailto:contact@bewise.in.">contact@bewise.in.</a>  </p>
                        <p className="termscond_para">You may also be contacted by the Partners with whom we have entered into a contract in
                          furtherance of our rights, duties and obligations under this document and all other policies
                          followed by us. Such contact will be made only in pursuance of such objectives, and no other calls
                          will be made.</p>
                        <p className="termscond_para">
                          The sharing of the information provided by you will be governed by BeWise’s Privacy Policy and
                          we will not give out your contact information to third parties not connected with this website/App.</p>
                        <h5> Permissions</h5>
                        <p className="termscond_para">We or our affiliates responsible for making the software available, may design our website or App
                          in such a manner as to automatically check for updates. Unless your device or any settings do not
                          permit automatic transmission, upgrades or updates, you agree that we, or the applicable software
                          affiliate, may provide notice to you of the availability of such upgrades or updates and
                          automatically push such upgrade or update to your device or computer from time-to-time. You
                          may be required to install certain upgrades or updates to the software in order to continue to
                          access or use the services, or portions thereof (including upgrades or updates designed to correct
                          issues with the services). Any updates or upgrades provided to you by us under these Terms shall
                          be considered part of the services.</p>
                        <p className="termscond_para">
                          BeWise has the right, but not the obligation to monitor and edit or remove any content posted by
                          you as your communication. We cannot review all communications made on the site/App.
                          However, we reserve the right, but has no obligation, to monitor and edit, modify or delete any
                          communications (or portions thereof) which we, on our sole discretion, deem inappropriate,
                          offensive or contrary to any of our policy, or that violate theses terms.</p>
                        <h5> Deals and offers</h5>
                        <p className="termscond_para"> BeWise provides an opportunity to users to avail offers/value deals from the Partners
                          listed on the website/App. BeWise allows users to book from amongst the services with offers
                          listed on them on the website or App. The user is aware that the term "Deal (Discount)" here
                          means the limited promotional offer, which is valid for the Promotional Period (as defined below)
                          only, made by the company, in terms of which the company offers to supply certain products and
                          services at a discounted rate and the term "Promotional Period" means the period of time during
                          which a Deal can be availed for the products and services offered on the website/App. Each deal
                          is limited and accordingly, will be sold on case-by-case basis on individual services offered on the
                          website/App’s promotional page. Each Deal has certain specific terms associated with the Deal,
                          which will be presented to the user before the user commits to purchase the particular product or
                          service. Deal specific terms supersede any inconsistent terms in this Agreement, except to the
                          extent such terms are prohibited by applicable law. The Promotional Period (including, but not
                          limited to, any discounts provided by the website/App) expires on a specific date specified on the
                          website/App. After the expiry date of the Promotional Period, such deals or offers become invalid.</p>

                        <h5> Charges</h5>
                        <p className="termscond_para">
                          The membership of this website/App for the user is free of cost. You only have to pay for the
                          services purchased. However, we reserve the right to amend this no-fee policy and charge for any
                          or all services rendered.
                        </p>
                        <h5>Mode of payment</h5>
                        <p className="termscond_para">The following payment options are or will be made available on the Website/App in the future:</p>
                        <ul>
                          <li>Domestic and international credit cards issued by banks and institutions that are part of the
                            Visa, Master card & Amex Card;</li>
                          <li>Visa Debit cards;</li>
                          <li>Netbanking/Direct Debit payments from select banks in India. A list of banks is available at
                            the time of ‘checkout’;</li>
                          <li>Payment processing apps like Paytm, Gpay, Razorpay, BHIM, Phonepe, Mobikwik, Yono,
                            Payzapp, Amazon pay etc.</li>
                        </ul>
                        <p className="termscond_para">As prescribed by the financial institutions issuing the credit or debit cards affiliated with Visa and
                          MasterCard you will be required to submit your 16-digit credit card number, card expiry date and
                          3-digit CVV number (usually on the reverse of the card) when you make your online transaction
                          using your credit or debit card. You should also have enrolled your credit card with VBV (Verified
                          by Visa) or MSC (MasterCard Secure Code) to complete the transaction. Your credit card or debit

                          card statements will reflect Wisdom Tech Solutions Pvt Ltd. In case of third-party statements
                          including bank and credit card statements the company name may appear in an abbreviated
                          format. This may or may not be assisted with a phone call with the customer service
                          representative. By placing an order on the website/App, you are agreeing to the terms and
                          conditions and payment policy published in the appropriate section of the website/App or
                          affiliated websites where specifically referred to such affiliated websites.</p>
                        <p className="termscond_para">Once payment has been made to the Partner, they will receive the SMS or mail with
                          booking details along with Service/Transaction ID, Login ID, One Time code.</p>
                        <p className="termscond_para">
                          Transactions on this website/App are secure and protected. Credit card and debit card
                          information is not stored by us and is not taken by us. This information is taken directly by the
                          payment gateway provided who is authorized and is compliant with the regulations and
                          requirements of various banks and institutions and payment franchisees that it is associated with.</p>
                        <h5>Intellectual Property Rights</h5>
                        <p className="termscond_para">This entire BeWise website/App has all rights reserved. The original contents of this website/App
                          are copyrighted materials and are subject to the restrictions and protections set forth in the
                          Copyright Act, 1957.</p>
                        <p className="termscond_para">
                          Unless we have otherwise agreed, nothing herein gives the user, a right to use any of the
                          website/App’s trade names, trademarks, service marks, logos, domain names, information,
                          questions, answers, solutions, reports and other distinctive brand features, save according to the
                          provisions of this Agreement.</p>
                        <p className="termscond_para">
                          All content, except if it relates to the individual and institutional partners, present on this
                          site/App is the exclusive property of BeWise. The software, text, images and graphics used on this
                          site/App belong to BeWise. The material present on this website/App may be downloaded to file
                          or printer for personal use only. Where this material is being issued to others, the source including
                          the URL and copyright status must be acknowledged.</p>
                        <p className="termscond_para">The permission to reproduce such copyright material does not extend to any material on this
                          site/App, which may be the property of a third party. This site/App may contain words and
                          phrases, which are copyrighted, trademarked, or registered trademarks; they are the copyright,
                          trademark, or registered trademark of their respective holder(s). Authorization to reproduce such
                          material must be obtained from the respective holders concerned.
                        </p>
                        <p className="termscond_para">
                          BeWise does not allow the user to directly or indirectly, modify, adapt, alter, reverse engineer any
                          of the intellectual property of this website/App.</p>
                        <p>The Logo is the property of BeWise and may not be used by third parties in any manner that
                          implies that the user is acting on behalf of BeWise when they are not, or where it is linked to aims
                          and activities incompatible with the role and responsibilities of BeWise.
                        </p>
                        <p className="termscond_para">
                          BeWise’s logo may be used for events/ programmes/ projects that are funded wholly or in part by
                          BeWise. BeWise’s logo may be used by a third party only with the prior written permission from
                          BeWise, which may be granted only at the sole discretion of BeWise. All rights not expressly
                          granted herein are reserved. Unauthorized use of the materials appearing on this site/App may
                          violate copyright, trademark and other applicable laws, and could result in criminal and/or civil
                          penalties.
                        </p>
                        <p className="termscond_para">
                          You may not use any of our intellectual property in any manner that is likely to cause confusion
                          among customers, or in any manner that disparages or discredits us in any way.
                          You further acknowledge that the website/App or services may contain information which is
                          designated as confidential by us and that you shall not disclose such information without our prior
                          written consent.
                        </p>
                        <p className="termscond_para">
                          We do not warrant or represent that your use of any content or materials displayed on the website
                          will not infringe rights of third parties not affiliated with us. You agree to immediately notify us
                          upon becoming aware of any claim that any content on the website/App or any services infringe
                          upon any intellectual property of any party including, but not limited to, copyright, trademark, or
                          other contractual, statutory, or common law rights.</p>
                        <h5>Lawful usage</h5>
                        <p>You agree and confirm that you will use the services provided by BeWise for lawful purposes only
                          and comply with all applicable laws and regulations while using this site/App. The user agrees to
                          provide true, accurate, complete and current information in all instances where such information
                          is requested.</p>
                        <p className="termscond_para">
                          BeWise reserves the right to confirm and validate the information and other details provided by
                          you at any point of time. If upon confirmation your details are found not to be true (wholly or
                          partly), BeWise has the right in its sole discretion to reject the registration and debar you from
                          using the services of BeWise without prior intimation whatsoever.</p>
                        <h5> Prohibited usage</h5>
                        <p className="termscond_para">The user shall not use this site/App while, including, but not limited to, rating a Partners
                          or posting a review, for any of the following purposes:</p>
                        <ul>

                          <li> Disseminating any unlawful, harassing, abusive, threatening, harmful, vulgar, obscene, or
                            otherwise objectionable material.
                          </li>
                          <li> Transmitting material that encourages conduct that results in civil liability or otherwise
                            breaches any relevant laws, regulations or code of practice or constitutes a criminal
                            offence.
                          </li>
                          <li> Gaining unauthorized access to other computer systems.
                          </li>
                          <li> Interfering with any other person’s use or enjoyment of this site/App.
                          </li>
                          <li> Breaching any applicable laws.
                          </li>
                          <li> Interfering or disrupting networks or websites connected to this site/App.
                          </li>
                          <li> Making, transmitting or storing electronic copies of materials protected by copyright
                            without the permission of the respective owner.</li>
                        </ul>
                        <h5> Limitation of Liability and warranty disclaimers</h5>
                        <p className="termscond_para">BeWise will not be liable for indirect, special, or consequential damages (or any loss of revenue,
                          profits, or data) arising in connection with this Agreement.</p>
                        <p className="termscond_para">BeWise is not liable for any loss resulting from any action taken or reliance made by you on any
                          information or material posted on this website/App (including, without limitation, Partner and other third party information).</p>
                        <p className="termscond_para">BeWise discounts/offers are promotional offers and shall be subject to the standard terms and
                          conditions and specific terms and conditions. BeWise discounts/offers are issued by the
                          institutions/individual partner and only such institutions shall be responsible for,
                          damages, charges, expenses, claims, liabilities and costs suffered by or in respect of a user, caused
                          in whole or in part by the institutions or which arises out of the goods and/or services provided.</p>
                        <p className="termscond_para">BeWise is not responsible for lost or stolen vouchers or the reference number mentioned on it.
                          These vouchers cannot be combined with any other gift vouchers, third party vouchers, or
                          promotions, unless otherwise specified by the Institution.</p>
                        <p className="termscond_para">In respect of Individual Partner who offer their services listed on our platform through a
                          medium (online or otherwise) outside of the host country (in this case outside India), the legal
                          requirement along with taxation implications of the same would be borne by the user and the
                          respective Partner. The company is not responsible for any such implications arising
                          from the transaction between both user and Partner.</p>
                        <p className="termscond_para">
                          In no event will BeWise be liable for damages of any kind, including without limitation, direct,
                          incidental or consequential damages (including, but not limited to, damages for lost profits,
                          business interruption and loss of programs or information) arising out of the use of or inability to
                          use BeWise's website/App, or any information provided on the website/App, or any claim
                          attributable to errors, omissions or other inaccuracies in the content or interpretations thereof.</p>
                        <p className="termscond_para">THIS SITE/APP, AND ALL CONTENT, MATERIALS, INFORMATION, SOFTWARE AND
                          SERVICES PROVIDED ON THIS SITE/APP, ARE PROVIDED ON AN "AS IS" AND "AS
                          AVAILABLE" BASIS. BEWISE EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND,
                          WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED

                          WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NON-
                          INFRINGEMENT.</p>
                        <p className="termscond_para">

                          THE INFORMATION CONTAINED IN THIS SITE/APP HAS BEEN OBTAINED FROM
                          INDIVIDUAL & INSTITUTIONAL PARTNERS AND OTHER SOURCES BELIEVED
                          TO BE RELIABLE. BEWISE DISCLAIMS ALL WARRANTIES AS TO THE ACCURACY,
                          COMPLETENESS OR ADEQUACY OF SUCH INFORMATION.</p>
                        <p className="termscond_para">You agree that institutions will have their own applicable terms and conditions, in relation to their
                          own supply of their goods and services, and also agree to, and shall abide by those terms and
                          conditions. The responsibility to do so is yours alone.</p>
                        <p className="termscond_para">BeWise makes no warranty that: (a) this site/App will meet your requirements; (b) this site/App
                          will be available on an uninterrupted, timely, secure, or error-free basis; (c) the results that may
                          be obtained from the use of this site/App or any services offered through this site/App will be
                          accurate or reliable.</p>
                        <p className="termscond_para">The limitations and exclusions in this section apply to the maximum extent permitted by
                          applicable law.</p>
                        <h5>Indemnity</h5>
                        <p className="termscond_para">You agree to defend, indemnify and hold harmless BeWise, its affiliates, employees, directors,
                          officers, agents and their successors and assigns from and against any and all claims, liabilities,
                          damages, losses, costs and expenses, including attorney’s fees, caused by or arising out of claims
                          based upon your actions or inactions, which may result in any loss or liability to us or any third
                          party including, but not limited to, posting of obscene or inappropriate content while reviewing
                          any Partner listed on this website/App, providing misleading information while
                          registering on this website/App, breach of any warranties, representations or undertakings or in
                          relation to the non-fulfillment of any of your obligations under this Agreement or arising out of
                          the violation of any applicable laws, regulations including, but not limited to, intellectual property
                          rights, defamation, violation of rights of privacy or publicity or other rights. Your obligations
                          under this part of this Agreement shall survive the expiry or cessation of this Agreement.</p>
                        <h5>Links to external sites</h5>
                        <p className="termscond_para">Information on our website/App may occasionally include some links which may lead to other
                          websites, including those operated and maintained by third parties or such other third-party sites
                          that might be directly or indirectly related to the individual or institutional partners listed
                          on our website/App. BeWise includes these links solely as a convenience to you and the presence
                          of such a link does not imply a responsibility on BeWise for the linked site or an endorsement of
                          the linked site, its operator, or its contents.</p>
                        <p className="termscond_para">Please be aware that once you click on the link to one of these sites, you will be subject to that
                          site's privacy policy and not to ours. We recommend that you examine each website's/App’s
                          Privacy Policy separately.</p>
                        <p className="termscond_para">BeWise also uses social networking services such as Facebook, Twitter, LinkedIn and Instagram
                          to connect with the users and the public. When you connect with us using these services, we may
                          collect your personal information to communicate with you. The social networking service will
                          also handle your personal information for its own purposes. These social networking services have
                          their own privacy policies. You can access the privacy policies for these social networking services
                          on their websites.</p>
                        <h5> Privacy</h5>
                        <p className="termscond_para">The user's right to privacy is of paramount importance to BeWise, which is why we've created a
                          separate Privacy Policy in order to explain in detail how we collect, manage, process, secure, and
                          store your personal information. To read our privacy policy in its entirety, go to the <b>Privacy
                            Policy</b> section of this website/App.</p>
                        <p className="termscond_para">By using this website/App, you agree to acceptance of BeWise’s <b>Privacy Policy</b>.</p>
                        <h5> Modifications</h5>
                        <p className="termscond_para">We reserve the right at all times to discontinue or modify the Terms and/or our Privacy Policy as
                          and when we deem necessary or desirable. Upon such discontinuance or modification of the
                          Terms and/or our Privacy Policy, the user registered on this website/App as a member shall be
                          notified via their registered email. Your continued use of this site/App after such modifications
                          being notified to you will constitute acknowledgment and agreement of the modified Terms
                          and/or our Privacy Policy.</p>
                        <h5> Miscellaneous terms</h5>
                        <p className="termscond_para">While BeWise makes every effort to ensure that the material on this website/App is accurate and
                          up-to-date, you should exercise your own independent skill and judgement before you rely on it.
                          This website/App is not a substitute for independent professional advice and users should obtain
                          any appropriate professional advice relevant to their particular circumstances.
                        </p>
                        <p className="termscond_para">
                          You obtain access to this website/App at your own risk and BeWise accepts no responsibility for
                          any interference, loss, damage or disruption to your own computer system which arises in
                          connection with your use of this website/App or any linked website. You must take your own
                          precautions to ensure that the process which you employ to obtain access to this website/App
                          does not expose you to the risk of viruses, malicious computer code or other forms of interference
                          which may damage your own computer system.</p>
                        <h5> Cessation</h5>
                        <p className="termscond_para">Without limiting the foregoing, we shall have the right to freeze/ discontinue/ delete the account
                          of the user in the event of any conduct by the user, including, but not limited to prohibited acts as
                          listed under the part ‘Prohibited usage’ in this Agreement, which we, in our sole discretion,
                          consider to be unacceptable, or in the event of any breach by the user of this Agreement. Any such
                          cessation of this Agreement shall not cancel your obligation or affect any liability that may have
                          arisen under this Agreement.</p>
                        <h5>Severability</h5>
                        <p className="termscond_para">If any part of the Terms and/or Privacy Policy are determined to be invalid or unenforceable
                          pursuant to applicable laws of India, including, but not limited to, the liability limitations and

                          warranty disclaimers set forth above, then the invalid or unenforceable provision will be deemed
                          to be superseded by a valid, enforceable provision that most closely matches the intent of the
                          original provision and the remainder of the Terms and/or Privacy Policy shall continue to be in
                          effect.</p>
                        <h5> Entire Agreement</h5>
                        <p className="termscond_para">Unless otherwise specified herein, this Agreement constitutes the entire agreement between you
                          and BeWise and supersedes all previous written and oral agreements between you and BeWise, if
                          any. BeWise’s failure to act with respect to a breach by you or others does not waive its right to act
                          with respect to subsequent or similar breaches.</p>
                        <h5> Dispute resolution and jurisdiction</h5>
                        <p className="termscond_para">If you choose to visit this website/App, your visit and any dispute over data privacy is subject to
                          this Agreement. In addition to the foregoing, any disputes arising under these Terms shall be
                          governed by the laws of India and the courts of Karnataka shall have exclusive jurisdiction in
                          determining such dispute.</p>
                        <p className="termscond_para">
                          In case of a dispute, the matter will first be attempted to be resolved by way of mediation by a sole
                          mediator who is a neutral third party and will be selected at the mutual acceptance of a proposed
                          mediator by both parties. Both parties may raise a name for sole mediator and in the case both
                          parties accept the proposed name, the said person shall be appointed sole mediator. In case the
                          parties are not able to reach a consensus within two proposed mediators, the Company reserves
                          the right to decide who the final mediator is. The parties in good faith will attempt to bind by the
                          decision.</p>
                        <h5> Contact Information</h5>
                        <p className="termscond_para">Questions about the Terms should be sent to us at <a href="mailto:contact@bewise.in">contact@bewise.in</a>.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className="modal fade " id="privacy_policy">
            <div className="modal-dialog model-box modal-lg">
              <div className="modal-content">
                <div className="modal-header heading_colour">
                  <h3 className="modal-title r-text">Privacy Policy</h3>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body termscond_body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="privacy-page">
                        <p className="termscond_para">
                          BeWise recognizes the importance of maintaining your privacy. We value your
                          privacy and appreciate your trust in us. This privacy policy is being
                          published in accordance with the provisions of the applicable provisions of
                          laws in India.
                        </p>
                        <p className="termscond_para">
                          This policy describes how we treat user information we collect on the Device
                          Support Application (“App”)/ website (named BeWise.in). This Privacy Policy
                          applies to current and former visitors to our App/ website. By visiting and/or
                          using our App/ website, you agree to this Privacy Policy.
                        </p>
                        <p className="termscond_para">This privacy policy was updated in September, 2020.</p>
                        <h5>1. General</h5>
                        <p className="termscond_para">
                          For the purpose of this Privacy Policy, wherever the context so requires,
                          ‘you’ or ‘user’ shall mean any natural or legal person who uses our
                          App/website, browses our website or becomes a member of our website by signing
                          up on BeWise as a user. BeWise allows the user to surf this website without
                          signing up on this website. The term “we”, “us”, “our” shall mean BeWise and
                          the term ‘site’ or ‘website’ refers to{" "}
                          <a href="www.bewise.in">www.BeWise.in</a>.
                        </p>
                        <h5>2. Information we collect</h5>
                        <p className="termscond_para">
                          Depending on your interaction with us (meaning, if you are just browsing our
                          website, or if you have signed up on this website, etc.), we may collect two
                          types of information from you, i.e. ‘Personal Information’ and ‘Non-Personal
                          Information’.
                        </p>
                        <h6>a) Personal Information</h6>
                        <p className="termscond_para">
                          Personal Information is the information that identifies a specific ‘End User’.
                          When you engage in certain activities on this website/App, such as signing up,
                          posting a review, rating a partner or any other third party listed on
                          our website/App, requesting information about our services or the services of
                          the third party partners listed on our website/App (collectively,
                          “Activities”), we may ask you to provide certain information about yourself or
                          your ward. It is optional for you to engage in an Activity. If you elect to
                          engage in an Activity, we may ask you to provide us with certain personal
                          information about yourself, such as your first and last name, email address,
                          telephone number, child’s name, age, etc. BeWise allows the user to sign up on
                          this website using social networking sites such as Facebook, Instagram, Google
                          accounts and LinkedIn, whereby, the user’s data may be shared by such social
                          networking sites with us.
                        </p>
                        <p className="termscond_para">
                          Depending on the activity, some of the information we ask you to provide is
                          identified as mandatory and some is identified as voluntary. If you do not
                          provide the mandatory information for a particular activity that requires it,
                          you will not be permitted to engage in that activity.
                        </p>
                        <p className="termscond_para">
                          We use Personal Information to enhance the operation of this website/App,
                          improve our marketing and promotional efforts, analyze website/App use,
                          improve our listings on the website/App, to personalize your experience and to
                          understand how our users, as a whole, use the services and resources provided
                          on our site/App and to provide you a better experience.
                        </p>
                        <p className="termscond_para">
                          In addition to this, your Personal Information may be used to troubleshoot,
                          resolve disputes, accomplish administrative tasks, contact you, enforce our
                          agreements with you, including our website Terms and Conditions and this
                          Privacy Policy, comply with applicable law, and cooperate with law enforcement
                          activities.
                        </p>
                        <h6>b) Non-Personal Information</h6>
                        <p className="termscond_para">
                          Non-Personal Information is the information that does not identify a specific
                          End User. This type of information may include things like the Uniform
                          Resource Locator (“URL”) of the website you visited before coming to our
                          website, the URL of the website you visit after leaving our website, the type
                          of browser you are using and your Internet Protocol (“IP”) address.
                        </p>
                        <p className="termscond_para">
                          We use Non-Personal Information to troubleshoot, administer this website/App,
                          analyze trends, gather demographic information, comply with applicable law,
                          and cooperate with law enforcement activities.
                        </p>
                        <h6>3. Utilising user’s information</h6>
                        <p className="termscond_para">
                          The information/data collected is used for the purposes of understanding the
                          user along with the location the user is from through geolocation platform, to
                          analyse our audience. Collecting this data helps us understand what you are
                          looking from the company, enabling us to deliver improved services.
                        </p>
                        <p className="termscond_para">We may use your data for the following general purposes:</p>
                        <ul>
                          <li> To contact you in response to a specific enquiry</li>
                          <li> To improve the services that we provide</li>
                          <li> To customise the website/App for you</li>
                          <li> For our internal records</li>
                          <li>
                            To send you promotional emails about products, services, offers and other
                            things we think might be relevant to you.
                          </li>
                          <li>
                            To contact you via email, telephone or mail for market research reasons.
                          </li>
                        </ul>
                        <h5>4. Release of user’s information</h5>
                        <p className="termscond_para">
                          We may disclose your information to other entities within BeWise’s company
                          group and its partners, for legitimate business purposes (including
                          operating the services, and providing services to you), in accordance with
                          applicable law. We may also disclose your information to any relevant
                          third-party partners listed on our website/App such as /preschools/
                          after school activity centers/schools/tuition centres/community support
                          centres, etc. for the purpose of providing appropriate services to you as per
                          your request.
                        </p>
                        <p className="termscond_para">
                          We will not sell, trade, distribute or lease your personal information to
                          third parties unless we have your permission or if required to do so by law or
                          in the good faith belief that such disclosure is reasonably necessary to
                          respond to court orders or other legal process.
                        </p>
                        <h5>5. Security</h5>
                        <p className="termscond_para">
                          We are committed to ensuring that your information is secure, but please note
                          that no method of transmission over the internet, or method of electronic
                          storage, is 100% secure. However, we will always hold your information
                          securely and prevent unauthorised disclosure or access to your information.
                          Further, by providing your information you allow us to share your information
                          with our partner brands/partners for their promotional purposes.
                        </p>
                        <p className="termscond_para">
                          For general web browsing, no Personal Information is revealed to us, although
                          certain statistical information is available to us via our internet service
                          provider. This information may include the logical address of the server you
                          are using, the top level domain name from which you access the internet (for
                          example, .com, .in, etc.), the type of browser you are using, the date and
                          time you access our site and the internet address used to link to our site.
                        </p>
                        <p className="termscond_para">
                          Some of the above information is used to create summary statistics, which
                          allow us to assess the number of visitors to our site and to identify what
                          pages of our site are accessed most frequently. We use these statistics to
                          help us make our site more user friendly.
                        </p>
                        <h5>6. Miscellaneous Privacy Issues</h5>
                        <p className="termscond_para">
                          This website/App is not meant to be used directly by children/minors under the
                          age of 18, and/or any person who is not capable of entering into a binding
                          contract. We do not collect or maintain information from anyone known to be
                          under the age of 18, unless such information has been lawfully provided by the
                          parents or guardians of the children and no part of this website/App is
                          designed to directly attract anyone under the age of 18 and/or any person who
                          is not capable of entering into a binding contract. If you are under 18, or
                          are not capable of entering into a binding contract, and still want to use
                          this website/App, you may use BeWise only with the involvement of a parent or
                          guardian.
                        </p>
                        <p className="termscond_para">We do not share, transfer, sell or trade children's information.</p>
                        <p className="termscond_para">
                          We may provide areas on our website/App where you can publicly post
                          information about yourself and provide reviews and ratings for the individual
                          and institutional partners listed on our website/App. This
                          information may be accessible by other users and may appear on other websites
                          or web searches, and therefore this information is not confidential and could
                          be read, collected, and used by others.
                        </p>
                        <h5>7. Links to external sites</h5>
                        <p className="termscond_para">
                          Information on our website/App may include some links which may lead to other
                          websites, including those operated and maintained by third parties or such
                          other third-party sites that might be directly or indirectly related to the
                          individual or institutional partners listed on our website/App.
                          BeWise includes these links solely as a convenience to you and the presence of
                          such a link does not imply a responsibility on BeWise for the linked site or
                          an endorsement of the linked site, its operator, or its contents.
                        </p>
                        <p className="termscond_para">
                          Please be aware that once you click on the link to one of these sites, you
                          will be subject to that site's privacy policy and not to ours. We recommend
                          that you examine each website's Privacy Policy separately.
                        </p>
                        <p className="termscond_para">
                          Apart from this website/App, the users may contact/ connect with BeWise using
                          social networking services such as Facebook, Twitter, LinkedIn and Instagram.
                          When you connect with us using these services, we may collect your personal
                          information to communicate with you. The social networking service will also
                          handle your personal information for its own purposes. These social networking
                          services have their own privacy policies. You can access the privacy policies
                          for these social networking services on their respective websites.
                        </p>
                        <h5>8. Cookies</h5>
                        <p className="termscond_para">
                          This website uses “cookie” technology. A cookie is a small piece of data or a
                          small text file stored by the browser on your computer, at the request of our
                          server. We may use cookies to deliver content specific to your interests and
                          to save your personal preferences so you do not have to re- enter them each
                          time you connect to our website – our cookies are not available to other
                          websites. In particular cookies enable us:
                        </p>
                        <ul className="list-dot">
                          <li>to measure visitor traffic to our website and their usage patterns</li>
                          <li>to identify whether you are signed in to our website</li>
                          <li>
                            to test content on our website and pattern of a user on the website. For
                            instance, 50% of our users might see one piece of content, the other 50% a
                            different piece of content.
                          </li>
                          <li>
                            to store information about your preferences and so allow us to customize our
                            website according to your individual interests
                          </li>
                          <li>to speed up your searches</li>
                          <li>to recognize you when you return to our website</li>
                        </ul>
                        <p className="termscond_para">
                          You are always free to decline such cookies, if your browser permits, or to
                          ask your browser to indicate when a cookie is being sent. You can also delete
                          cookie files from your computer at your discretion. However, please note that
                          doing this may affect how our website functions. Some pages and services may
                          become unavailable to you.
                        </p>
                        <p className="termscond_para">
                          To learn more about cookies and how they are used, visit{" "}
                          <a href="http://www.allaboutcookies.org/">http://www.allaboutcookies.org/</a>.
                        </p>
                        <h5>9. Advertising cookies</h5>
                        <p className="termscond_para">
                          Some of the advertisements you see on BeWise are provided by other
                          organizations. These organizations can use their own anonymous cookies to
                          track how many people have seen a particular ad, or to track how many people
                          have seen it more than once.
                        </p>
                        <p className="termscond_para">
                          The entities that generate these cookies have their own privacy policies, and
                          we have no access to read or write these cookies. These organizations may use
                          their cookies to anonymously target advertising to you on other websites,
                          based on your visit to BeWise.
                        </p>
                        <h5>10. Electronic communication</h5>
                        <p className="termscond_para">
                          There are inherent risks associated with the transmission of information over
                          the internet, including via email. You should be aware of this when sending
                          your personal information to us via email or via our website/App or social
                          media platforms. If this is of concern to you then you may use other methods
                          of communication with us, such as post or telephone (although these also have
                          risks associated with them).
                        </p>
                        <h5>11. Changes to this privacy policy</h5>
                        <p className="termscond_para">
                          Please note that the privacy policy may change from time to time. BeWise
                          reserves the right to change this policy at any time. The users registered on
                          this website/App as a member shall be notified of the changes or
                          modifications, if any, done on this policy via their registered email by
                          BeWise.
                        </p>
                        <h5>12. Your Acceptance of these terms</h5>
                        <p className="termscond_para">
                          By using this website/App, you signify your acceptance of our privacy policy.
                          If you do not agree to this policy, please do not use our website/App. Your
                          continued use of this website/App following the posting of changes to this
                          policy, as and when notified to you, will be deemed your acceptance of those
                          changes.
                        </p>
                        <h5>13. Jurisdiction</h5>
                        <p className="termscond_para">
                          If you choose to visit this website/App, your visit and any dispute over data
                          privacy is subject to this policy and the terms and conditions of this
                          website/App. In addition to the foregoing, any disputes arising under this
                          policy shall be governed by the laws of India and the courts of Karnataka
                          shall have exclusive jurisdiction in determining such dispute.
                        </p>
                        <h5>14. Complaints</h5>
                        <p>
                          If you think BeWise may have breached your privacy, you may contact us to make
                          a complaint and rectify our actions. In order to ensure that we fully
                          understand the nature of your complaint and the outcome you are seeking, we
                          prefer that you make your complaint in writing via email to the below
                          mentioned email address.
                        </p>
                        <p className="termscond_para">
                          Further, in accordance with Information Technology Act, 2000 and rules made
                          thereunder, the name and contact details of the grievance officer who can be
                          contacted with respect to any complaints or concerns including those
                          pertaining to breach of BeWise’s Terms & Conditions, and other polices or
                          questions are published as under:
                        </p>
                        <p className="termscond_para">
                          Name: Sethuraman
                          <br />
                          Email Address: <a href="mailto:contact@bewise.in">contact@bewise.in</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="copyright"
            style={{ padding: "15px" }}
          >
            <p>
              &copy; Copyright 2025 <strong>BeWise</strong>.&nbsp;All Rights Reserved
            </p>
          </div>
        </footer>
      </React.Fragment>
    )
  }
}


export default Footer;





// WEBPACK FOOTER //
// ./src/components/Copyrights/Footer.jsx